//-----------------------\\
//--- Carousel Slicks ---\\
//-----------------------\\
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Toutes les fonctions utilisant les carousel de slick se retrouve ici. Ces fonction ont besoin du
// node-module slick carousel pour fonctionner (et le css qui vient avec).
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
//-----------------------------------------------------------------------------------------------------------------

// Création du slick de la bannière
export function slickBanner() {
  $('#slickBanner').on('init', function(event, slick){
    $(window).on('resize', () => {
      $('.bannerBlock button').css('height', ($('.bannerBlock .slick-dots').height() / slick.slideCount ))
    })
    $('.bannerBlock button').css('height', ($('.bannerBlock .slick-dots').height() / slick.slideCount ))
    if(slick.slideCount <= 1) $('.slickArrows').css('display', 'none')
  })

  $('#slickBanner').slick({
    arrows: false,
    appendDots: $('.bannerBlock .slickNav'),
    dots: true,
    infinite: true,
    autoplay: true,
    draggable: true,
    pauseOnHover: false,
    fade: true,
    autoplaySpeed: 10000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  })

  $('.bannerBlock .slickPrev').click(function(){
    $('#slickBanner').slick('slickPrev')
  })

  $('.bannerBlock .slickNext').click(function(){
    $('#slickBanner').slick('slickNext')
  })
}


// Création du slick de la bannière
export function slickEvents() {
  $('#slickEventsImages').on('init', function(event, slick){
    window.lazyLoad.lazyBackground()
  })

  $('#slickEventsImages').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    draggable: true,
    pauseOnHover: true,
    autoplaySpeed: 20000,
    speed: 1000,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '#slickEventsText'
  })

  $('#slickEventsText').slick({
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    draggable: true,
    fade: true,
    pauseOnHover: true,
    autoplaySpeed: 20000,
    speed: 1000,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '#slickEventsImages'
  })

  $('.eventBlock .slickPrev').click(function(){
    $('#slickEventsImages').slick('slickPrev')
  })

  $('.eventBlock .slickNext').click(function(){
    $('#slickEventsImages').slick('slickNext')
  })
}



// Fonction permettant de détruire un carousel Slick
export function destroySlick(carousel, delai) {
  // Paramètres optionnels
  delai = (typeof delai === 'undefined') ? 1000 : delai

  // Un délai pour que le slick ne se détruise pas avant que la transition de page ne soit apparu
  setTimeout(function() {
    $(carousel).slick('unslick')
  }, delai)
}
